export default "__VITE_ASSET__Do8RxFv1__"